module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz19-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_17",
      "id": "CC_17"
    }
  }, [_vm._v(" Lady Shoplifter’s Chocolate Nonfat Milkshake")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz19-3"
    }
  }, [_c('i', [_vm._v(" Keeps you light on your feet. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz19-4"
    }
  }, [_c('b', [_vm._v(" 1 pint chocolate nonfat yogurt or ice cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz19-5"
    }
  }, [_c('b', [_vm._v(" 4 cups nonfat milk (3 if you like it thick) ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz19-6"
    }
  }, [_c('b', [_vm._v(" 8 heaping tablespoons chocolate Ovaltine ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz19-7"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("B")]), _vm._v("lend ingredients until you can drink mixture through a straw. If you can’t drink it all, put it in a plastic cup and freeze it. It tastes good that way, too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-8"
    }
  }, [_vm._v(" Serves 4 to 6.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pz19-9"
    }
  }, [_c('i', [_vm._v("Sam Bobrick—Writer")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pz19-10"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-19-1.jpg",
      "id": "z19-10",
      "src": "images/img-19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pz19-11"
    }
  }, [_c('i', [_vm._v("Down the stretch")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx3k",
    attrs: {
      "id": "pz19-12"
    }
  }, [_vm._v("GREAT MOMENTS ")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "pz19-13"
    }
  }, [_vm._v(" Among the most popular episodes written by Sam Bobrick and partner Bill Idelson are “The Shoplifters” (Episode #117), “A Deal Is a Deal” (Episode #122), “Barney and Thelma Lou, Phfft!” (Episode #126), “Barney’s Bloodhound” (Episode #128), “Barney Fife, Realtor” (Episode #143), and “Goober Takes a Car Apart” (Episode #144).")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b36c2bc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter17.vue
// module id = 114
// module chunks = 0